import React from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "../../ui/dialog";
import { ShieldOff } from "lucide-react";
import { Button } from "../../ui/button";

export const Forbidden = (props) => {
    const confirmLogout = () => {
        localStorage.clear();
        window.location.pathname = "/login";
    }

    return (
        <Dialog open={true} onOpenChange={() => { }}>
            <DialogContent className="max-w-sm text-center [&>button]:hidden" onEscapeKeyDown={(e) => e.preventDefault()}>
                <DialogHeader className="items-center gap-3 pb-2">
                    <div className="flex h-16 w-16 items-center justify-center rounded-full bg-red-100 dark:bg-red-900/30">
                        <ShieldOff className="h-8 w-8 text-red-600 dark:text-red-400" />
                    </div>
                    <div>
                        <DialogTitle className="text-lg font-semibold text-red-600 dark:text-red-400">
                            Access Denied
                        </DialogTitle>
                        <p className="mt-1 text-sm text-muted-foreground">
                            403 Forbidden
                        </p>
                    </div>
                </DialogHeader>

                <div className="rounded-lg border border-red-200 bg-red-50 dark:border-red-800 dark:bg-red-900/10 px-4 py-4">
                    <p className="text-sm text-red-700 dark:text-red-300 leading-relaxed">
                        You don't have the required permission to perform the selected operation.
                        Please contact your administrator if you believe this is a mistake.
                    </p>
                </div>

                <DialogFooter className="justify-center sm:justify-center">
                    <Button
                        variant="destructive"
                        className="w-full sm:w-auto"
                        onClick={confirmLogout}
                    >
                        Return to Login
                    </Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
};

export default Forbidden;